export interface GqlError {
  message: string
  path: string[]
  extensions?: {
    code?: string
    stack?: string
    [key: string]: any
  }
}

export type GqlResponse<T = unknown> = {
  data?: T
  errors?: GqlError[]
}

export type GqlRequest<TVariables = unknown> = {
  query: string
  variables?: TVariables
}

let nextClientId = -1

export function createTmpClientId(): number {
  return nextClientId--
}

export function isClientId(id: number): boolean {
  return id < 0
}

export function isServerId(id: number): boolean {
  return id >= 0
}
